module.exports = __webpack_public_path__ + "img/yd.2ffad1cd.png";